<template>
  <div v-if="toShow" class="container adn-discount-banner" data-test-advertisement>
    <idf-component-link :url="link" :class="linkClassNames" data-test-cta-link>
      <adn-image :source="imageSrc" :alt="description" data-test-image class="adn-discount-banner__image" />
    </idf-component-link>
  </div>
</template>

<script lang="ts">
import AdnImage from '../AdnImage/AdnImage.vue'
import IdfComponentLink from '../IdfComponentLink/IdfComponentLink.vue'

export default {
  name: 'AdnDiscountBanner',
  components: {
    AdnImage,
    IdfComponentLink,
  },
  props: {
    desktopImage: {
      type: String,
      default: null,
    },
    mobileImage: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: () => '',
    },
    description: {
      type: String,
      default: null,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    linkClassNames() {
      const classNames = ['adn-discount-banner__link']
      if (this.isSmall) {
        classNames.push('adn-discount-banner__link--small')
      }
      return classNames
    },
    toShow() {
      return this.desktopImage && this.mobileImage
    },
    imageSrc() {
      return [
        { url: this.desktopImage, media: '(min-width: 768px)', sizes: '100vw' },
        { url: this.mobileImage, sizes: '100vw' },
      ]
    },
  },
}
</script>

<style scoped lang="scss">
.adn-discount-banner {
  width: 100%;
  display: flex;
  justify-content: center;
}

.adn-discount-banner__link {
  display: flex;
  width: 100%;
  height: 100%;

  @media (min-width: $breakpoint-md) {
    max-width: 111rem;
    max-height: 15rem;
  }
}

.adn-discount-banner__link--small {
  width: 100%;

  @media (min-width: $breakpoint-md) {
    max-width: 72.8rem;
    max-height: 9rem;
  }

  max-width: 32rem;
  max-height: 10rem;
}

.adn-discount-banner__image {
  width: 100%;
}
</style>
